<template>
  <a-modal
    title="文件详情"
    style="top: 20px;"
    :width="1350"
    v-model="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    @ok="handleSubmit"
  >
    <a-tabs
      default-active-key="1"
      :tab-position="top"
      @prevClick="callback"
      @nextClick="callback"
      @change="callback"
      v-show="isTrue == 1"
      :default-active-key="installType"

    >
      <a-tab-pane v-for="i in labelList" :key="i.installName" :tab="i.installName" :disabled="installType==i.installName?false:true">
        <div class="table-page-search-wrapper">
          <a-form layout="inline">
            <a-row :gutter="16">
              <a-col :span="6">
                <a-form-item label="企业名称">
                  {{mdl.enterpriseName}}
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="品牌">
                  {{mdl.brandName}}
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="型号">
                  {{mdl.modelName}}
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="订单类型">
                  {{mdl.orderType}}
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <a-tabs default-active-key="1" @change="callback">
          <a-tab-pane key="1" tab="图片">
            <div>
              <div :style="{'text-align': 'center',display:'inline-block',margin:'20px 0px',width:'20%'}" v-for="item in imgList" :key="item.picAndVideoType">
                <div style="display: flex;flex-direction: column;justify-content: center;align-items: center">
                <div>{{item.picAndVideoType}}</div>
                <div style="width: 60%;height: 116px;line-height: 116px"><img style="width: 100%" :src="item.url+'&token='+token"></div>
                  <!--<video :src="urlvideo+'&token='+token" controls></video>-->
                <div>{{item.createTime}}</div>
                </div>
              </div>
            </div>
          </a-tab-pane>
          <a-tab-pane key="2" tab="视频">
            <div>
              <div :style="{'text-align': 'center',display:'inline-block',margin:'20px 0px',width:'20%'}" v-for="item in videoList" :key="item.picAndVideoType">
                <div style="display: flex;flex-direction: column;justify-content: center;align-items: center">
                  <div>{{item.picAndVideoType}}</div>
                  <div style=""><video style="width: 100%" :src="item.url+'&token='+token"/></div>

                  <div>{{item.createTime}}</div>
                </div>
              </div>
            </div>
          </a-tab-pane>
        </a-tabs>
      </a-tab-pane>
    </a-tabs>
    <div v-show="isTrue == 2" style="text-align: center">
      <a-divider></a-divider>
      <span>暂无数据</span>
    </div>
  </a-modal>
</template>

<script>
  import {ACCESS_TOKEN} from '@/store/mutation-types'
  import {databaseGet,databasevideoList} from '@/api/basicdatas/DataBank'
  import { saveInstallLabel,queryInstallLabel } from '@/api/master/LabelManagement'
  import pick from 'lodash.pick'
  import { getDictMap } from "../../../utils/dict"

  export default {
    name: "DataBankModel",
    components: {
    },
    data () {
      return {
        visible: false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        confirmLoading: false,
        mdl: {},
        token: Vue.ls.get(ACCESS_TOKEN),
        form: this.$form.createForm(this),
        restaurantTypes:[],
        restaurantOperTypeMap:[],
        labelList:[],
        isTrue:1,
        installType:'',
        imgList:[],
        videoList:[],
        widthdu:''
      }
    },
    beforeCreate () {
    },
    async created () {
      queryInstallLabel().then(res=>{
        console.log(res.rows)
        this.labelList = res.rows

      })

    },
    methods: {
      onChange(date,dateString) {
        console.log(dateString)
        this.startTime=dateString[0]
        this.endTime=dateString[1]
      },
      add() {
        this.form.resetFields()
        this.edit({installLabelId: 0})
      },
      edit(record) {
        this.mdl = Object.assign(record)
        this.visible = true
        this.installType=record.installType
        databaseGet({orderId:record.orderId}).then(res=>{
          console.log(res.rows.length)
          if(res.rows.length>0){
            this.imgList=res.rows[0].previewFileList
          }else{
            this.$message.error('暂无数据')
          }
        })
      },
      callback(val) {
        console.log(val);
        if(val==1){
          databaseGet().then(res=>{
            console.log(res.rows)
            console.log(res.rows[0].previewFileList)
            if(res.rows.length>0){
              this.imgList=res.rows[0].previewFileList
              for(var i=0;i<this.imgList.length;i++) {
                this.imgList[i].url = process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=/' + this.imgList[i].url
              }
            }else{
              this.$message.error('暂无数据')
            }
          })
        }else if(val==2){
          databasevideoList().then(res=>{
            console.log(res.rows)
            if(res.rows.length>0){
              this.videoList=res.rows[0].previewFileList
              for(var i=0;i<this.videoList.length;i++) {
                this.videoList[i].url = process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=/' + this.videoList[i].url
              }
            }else{
              this.$message.error('暂无数据')
            }
          })
        }

      },
      // handleSubmit(e) {
      //   console.log(this.getSubmit)
      //   e.preventDefault()
      //   this.form.validateFields((err, values) => {
      //     if (!err) {
      //       console.log('Received values of form: ', values)
      //       this.confirmLoading = true
      //       if (!err) {
      //         console.log('Received values of form: ', values)
      //         this.confirmLoading = true
      //         saveInstallLabel(values).then(res => {
      //           if (res.code === 0) {
      //             this.$message.success('保存成功')
      //             this.$emit('ok')
      //             this.visible = false
      //           } else {
      //             this.$message.success(res.msg)
      //           }
      //         }).catch(() => {
      //           this.$message.error('系统错误，请稍后再试')
      //         }).finally(() => {
      //           this.confirmLoading = false
      //         })
      //       }
      //     }
      //   })
      // }
    }
  }
</script>

<style scoped>

</style>